import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { MoveTaskFilesToFileGroupRequestInterface } from './definitions/move-task-files-to-file-group-request.interface';

@Injectable()
export class MoveTaskFilesToFileGroupService {
  constructor(private httpClient: HttpClient, private configService: ConfigService) {}

  public moveFiles(
    taskId: string,
    targetTaskFileGroupId: string | null,
    request: MoveTaskFilesToFileGroupRequestInterface
  ): Observable<any> {
    const url = this.buildUrl(taskId, targetTaskFileGroupId);

    return this.httpClient.post(url, request).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }

  private buildUrl(taskId: string, targetTaskFileGroupId: string | null): string {
    const baseUrl = this.configService.config.rest.apiV2Url;
    
    return targetTaskFileGroupId === null
        ? `${baseUrl}/tasks/${taskId}/task-file-groups/files/remove`
        : `${baseUrl}/tasks/${taskId}/task-file-groups/${targetTaskFileGroupId}/files/move`;
  }
}
